// extracted by extract-css-chunks-webpack-plugin
module.exports = {"logo":"logo-3f5gCMze","breadcrumbs":"breadcrumbs-2ShHrZt2"};